<section class="file-handler-wrapper">
  @if (showUploadButton) {
    <div class="button-container">
      <gc-button
        variant="secondary"
        [icon]="data.type === 'FILE' ? 'fileLines' : 'upload'"
        iconSize="medium"
        (clicked)="
          data.type === 'FILE' ? fileUpload.click() : imageUpload.click()
        "
        >{{
          data.type === 'FILE'
            ? ('reportInput.upload.files' | translate)
            : ('reportInput.upload.images' | translate)
        }}</gc-button
      >
      @if (optionsButton) {
        <app-options-button
          [id]="id"
          [isDone]="isSelfInspectionDone"
          [disableUndo]="disableUndo"
        />
      }
    </div>
  }
  @if (data.type === 'IMAGE') {
    @if (isSelfInspectionDone) {
      <div class="button-container">
        <gc-button
          variant="utility"
          size="small"
          icon="image"
          (clicked)="viewImages.emit()"
          >{{
            ('reportInput.viewImages' | translate) +
              ' (' +
              data.imageAmount +
              ')'
          }}</gc-button
        >
        @if (optionsButton) {
          <app-options-button
            [id]="id"
            [isDone]="true"
            [type]="'UPLOAD'"
            [mimeType]="data.mimeType"
            [disableUndo]="disableUndo"
          />
        }
      </div>
    }
  }
  @if (data.type === 'FILE') {
    <ul>
      @for (file of data.files; track file) {
        <li>
          <gc-button
            variant="utility"
            size="small"
            icon="file"
            (clicked)="handleClickFile($event, file)"
            >{{ file.fileName }}</gc-button
          >
        </li>
      }
    </ul>
  }
</section>

@if (showPopup) {
  <app-options-popup
    [fileName]="clickedFile.fileName"
    (closePopup)="closePopup()"
    (download)="handleClickDownload()"
    (delete)="handleClickDelete()"
    [ngStyle]="{
      'top.px': popupPosition?.top,
      'left.px': popupPosition?.left,
      position: 'absolute',
    }"
  />
}

<input
  #imageUpload
  (change)="handleUploadFiles($event)"
  multiple="multiple"
  type="file"
  name="picture"
  [accept]="data.mimeType"
  class="file-upload-input"
  [style.display]="'none'"
/>

<input
  #fileUpload
  (change)="handleUploadFiles($event)"
  multiple="multiple"
  type="file"
  name="picture"
  [accept]="data.mimeType"
  class="file-upload-input"
  [style.display]="'none'"
/>
